"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CornerButton = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
exports.CornerButton = ({ size, color, style = {}, ...props }) => {
    return (react_1.default.createElement("div", Object.assign({}, props, { style: {
            display: "block",
            width: size,
            height: size,
            borderStyle: "solid",
            borderWidth: `0 ${size * 2}px ${size * 2}px 0`,
            borderColor: `transparent ${color} transparent transparent`,
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: 10,
            ...style,
        } })));
};
exports.CornerButton.propTypes = {
    size: prop_types_1.default.number.isRequired,
    color: prop_types_1.default.string.isRequired,
    children: prop_types_1.default.any,
    style: prop_types_1.default.any,
};
//# sourceMappingURL=CornerButton.js.map